import request from '@/utils/request'

let DictApi = {

  /*字典列表*/
  list(data) {
    return request._post('/shop/plus.dict.Index/index', data);
},
/*添加字典*/
add(data) {
    return request._post('/shop/plus.dict.Index/add', data);
},
/*修改字典*/
edit(data) {
    return request._post('/shop/plus.dict.Index/edit', data);
},
/*删除字典*/
del(data) {
    return request._post('/shop/plus.dict.Index/del', data);
},
/*字典详情*/
detail(data) {
  return request._post('/shop/plus.dict.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.dict.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.dict.Setting/getSetting', data, errorback);
    },
}
export default DictApi;



// WEBPACK FOOTER //
// ./src/api/dict.js